const ja = {
  absoluteCount: '絶対人数',
  action: '操作',
  actions: {
    cancel: '取消',
    confirm: '確定',
    delete: '削除',
    edit: '編集',
  },
  activityTime: '滞在時間',
  activityType: {
    eat: '食事',
    entertainment: 'エンターテインメント',
    grocery: '食品・日用品等購入',
    medical: '通院',
    outdoor: 'アウトドア',
    retail: '買い物',
    home: '帰宅',
    work: '通勤',
    others: 'その他',
  },
  additionalInfos: {
    activityTime:
      '滞在は1時間ごとに区切った中で15分以上同じ位置（約100m）に留まった場合を滞在として判定しています。',
    ageGroup:
      '年代は携帯電話の契約者情報（統計データ）を元に推定しており、未成年者のプライバシー保護のため20歳未満の人は含みません。',
    arrival:
      '出発地点のみを条件にした場合、自動的に同じエリア内の移動（=回遊）を除くようになっています。',
    customArea:
      'カスタムエリアとは、「ジオフェンス」とも呼ばれるユーザーが地図上に自由に描画して設定できるエリアのことです。',
    departure:
      '到着地点のみを条件にした場合、自動的に同じエリア内の移動（=回遊）を除くようになっています。',
    endActivityType:
      '移動目的は到着地点の位置や施設種別、滞在時間を元に総合的に推定しています。',
    excursion: '回遊とは同じエリア内での移動を指します。',
    gender: '性別は携帯電話の契約者情報（統計データ）を元に推定しています。',
    gridHeatmap:
      'グリッドは標準地域メッシュ（第3次メッシュ〜10mメッシュ）に対応しています。',
    home: '居住地は対象期間において深夜22時〜翌朝5時に最も多く滞在した場所として判定しています。',
    longestDistanceMode:
      '移動手段は移動速度や交通ネットワーク情報を元に総合的に推定しています。',
    odMap:
      'ODマップとは行政区画や地域メッシュごとの移動人数と滞在人数を可視化する地図表現です。',
    odMapCutoff: [
      'デフォルトでは、見やすさのため最大の移動回数の10%以下の移動は除外しています。',
      'チェックを付けることですべての移動が表示されます。',
    ],
    passageTime: '通過時刻は各道路・路線へ進入した時間として判定しています。',
    scale: [
      '等分位は上位〇〇%ごとに分ける相対区分であり、等間隔は一定間隔に設けた閾値ごとに分ける絶対区分です。',
      '等間隔は突出したデータを強調するのに適しており、等分位は値の差が小さい部分のデータを見やすくするのに適しています。',
      'また、実際のデータの分布に応じて色分けされるため、色分けの数が指定した数以下になることがあります。',
    ],
    targetAgentCount: [
      '設定した分析条件に該当する一意な人数です。',
      '同じ人が複数回移動をした場合でも、1人としてカウントされます。',
    ],
    trafficVolume:
      '交通量マップは道路・路線の交通量の多さを色で可視化する地図表現です。',
    tripPath:
      '移動経路マップは出発地と到着地をアークで結び可視化する地図表現です。',
    visitor:
      '来街者とは対象エリアに到着した人のうち、居住者でも勤務者でもない人を指します。',
    walkingDistance: [
      '徒歩圏とは、実際の道路ネットワークに基づき、一般的な成人の歩行速度（約5km/h）で歩いた場合に到達可能な範囲を示しています。',
      'ただし道路の種類や勾配、信号の有無などの影響を考慮し総合的に推定しています。',
    ],
    work: '勤務地は対象期間の平日8〜20時に合計6時間以上滞在した場所（ただし居住地を除く）として判定しています。',
  },
  advancedAnalysis: '高度な分析',
  ageGroup: '年代',
  ageGroups: {
    '10s': '10代',
    '20s': '20代',
    '30s': '30代',
    '40s': '40代',
    '50s': '50代',
    '60s': '60代',
    '60s+': '60代以上',
    '70s': '70代',
  },
  prefNames: {
    '01': '北海道',
    '02': '青森県',
    '03': '岩手県',
    '04': '宮城県',
    '05': '秋田県',
    '06': '山形県',
    '07': '福島県',
    '08': '茨城県',
    '09': '栃木県',
    '10': '群馬県',
    '11': '埼玉県',
    '12': '千葉県',
    '13': '東京都',
    '14': '神奈川県',
    '15': '新潟県',
    '16': '富山県',
    '17': '石川県',
    '18': '福井県',
    '19': '山梨県',
    '20': '長野県',
    '21': '岐阜県',
    '22': '静岡県',
    '23': '愛知県',
    '24': '三重県',
    '25': '滋賀県',
    '26': '京都府',
    '27': '大阪府',
    '28': '兵庫県',
    '29': '奈良県',
    '30': '和歌山県',
    '31': '鳥取県',
    '32': '島根県',
    '33': '岡山県',
    '34': '広島県',
    '35': '山口県',
    '36': '徳島県',
    '37': '香川県',
    '38': '愛媛県',
    '39': '高知県',
    '40': '福岡県',
    '41': '佐賀県',
    '42': '長崎県',
    '43': '熊本県',
    '44': '大分県',
    '45': '宮崎県',
    '46': '鹿児島県',
    '47': '沖縄県',
  },
  agentAnalysis: '人の分析',
  agentCount: '人数',
  agentInGrid: 'グリッド内人数',
  aggregatedBy: '毎の集計を地図上に表示',
  aggregationTarget: '集計対象',
  aggregationTargetByDimension: '{{target}}（{{dimension}}）',
  aggregationTypes: {
    areaPref: '行政区画（都道府県）',
    areas: '行政区画（町丁目・市区町村）',
    arcs: 'アーク',
    gridHeatmap: 'グリッドヒートマップ',
    heatmap: 'ヒートマップ',
    links: '交通量',
    odMap: 'ODマップ',
  },
  all: 'すべて',
  analysisResults: '分析結果',
  analyzeOtherData: '他の都道府県を分析する',
  and: 'かつ',
  apply: '適用',
  applyCondition: '条件を適用する',
  area: 'エリア',
  areas: {
    city: '市区町村',
    state: '行政区画',
    town: '町丁目',
  },
  arrivalTime: '到着時刻',
  arrived: '{{place}}に到着した',
  barChartTitle: '{{target}}別棒グラフの比較',
  bugfix: '不具合修正',
  cancel: 'キャンセル',
  checkAnalysis: '分析結果を確認',
  circle: '円',
  clearAll: 'すべてクリア',
  clickOrDropToUpload:
    'クリックまたはファイルをドラッグしてアップロードしてください。',
  close: '閉じる',
  color: '色',
  compare: '比較',
  compareDataMultipleMaps: '複数のデータ間の地図を比較します',
  compareMaps: '地図比較',
  convertToPolygon: '多角形に変換',
  copySharableUrlInClipboard:
    '現在の地図を共有するURLをクリップボードにコピーします',
  countPerArea: '面積当たり人数',
  countries: {
    AUS: 'オーストラリア',
    CAN: 'カナダ',
    CHN: '中国',
    DEU: 'ドイツ',
    ESP: 'スペイン',
    FRA: 'フランス',
    GBR: 'イギリス',
    HKG: '香港',
    IDN: 'インドネシア',
    IND: 'インド',
    ITA: 'イタリア',
    JPN: '日本',
    KOR: '韓国',
    MYS: 'マレーシア',
    PHL: 'フィリピン',
    RUS: 'ロシア',
    SGP: 'シンガポール',
    THA: 'タイ',
    TWN: '台湾',
    USA: 'アメリカ',
    VNM: 'ベトナム',
    ZZZ: 'その他',
  },
  create: '新規作成',
  creatingCustomArea: 'カスタムエリア（{{type}}）を作成中',
  crossAnalysis: 'クロス分析',
  csvDownload: 'CSV出力',
  csvDownloadUtf8: 'UTF-8でダウンロード',
  csvDownloadUtf8Bom: 'エクセル対応UTF-8（BOM付き）でダウンロード',
  cumulative: '延べ',
  currentFilters: '適用中のフィルター',
  custom: 'カスタム',
  customArea: 'カスタムエリア',
  customAreaName: 'カスタムエリア名',
  dark: 'ダーク',
  departed: '{{place}}を出発した',
  departureTime: '出発時刻',
  discardChanges: '変更を破棄',
  display: '表示',
  displayAs: '表示方法',
  distribution: '分布',
  done: '完了',
  dontShowAgain: '今後表示しない',
  download: 'ダウンロード',
  downloading: 'ダウンロード中…',
  editMember: 'メンバー編集',
  editingCustomArea: 'カスタムエリア（{{type}}）を編集中',
  emailAddress: 'メールアドレス',
  endActivity: '移動目的',
  endPlace: '到着地',
  error: 'エラー',
  excursioned: '{{place}}を回遊した',
  expiry: '有効期限',
  export: 'エクスポート',
  feature: '新機能',
  features: {
    resident: '居住者',
    visitor: '来街者',
    worker: '勤務者',
  },
  file: 'ファイル',
  filter: 'フィルター',
  filterBy: {
    features: '人の属性で絞り込む',
    move: '移動で絞り込む',
  },
  gender: '性別',
  genders: {
    male: '男性',
    female: '女性',
  },
  hide: '非表示',
  holiday: '休日',
  home: '居住地',
  importCustomArea: 'カスタムエリアをインポート',
  improvement: '機能改善',
  instructions: '操作説明',
  inviteMember: 'メンバー招待',
  invitedDatetime: '招待日時',
  invitingMembers: '招待中のメンバー',
  language: '言語',
  lat: '緯度',
  legend: '凡例',
  light: 'ライト',
  link: {
    highway: '高速道路',
    otherRoad: 'その他道路',
    railway: '鉄道路線',
    trunkRoad: '主要道路',
  },
  list: '一覧',
  listOthers: 'ほか{{count}}件',
  listDelimiter: '・',
  load: '読み込む',
  loading: '読み込み',
  loadingNow: '読み込み中…',
  login: 'ログイン',
  logout: 'ログアウト',
  longestDistanceMode: '移動手段',
  lon: '経度',
  manageOrg: '組織管理',
  manual: 'マニュアル',
  map: '地図',
  mean: '平均値',
  median: '中央値',
  memberName: 'ユーザー名',
  mesh: 'メッシュ',
  message: {
    analysisConditionApplied: '「{{name}}」の分析条件が適用されました',
    cancelingInvitation: '招待を取消中...',
    cannotDownload: '対象人数が30万人以下のときのみダウンロードが可能です',
    checkAnalysis:
      '地図やグラフで分析結果を確認しましょう。複数の条件を組み合わせて、さまざまな視点からデータを分析できます。',
    confirmCancelInvitation: '「{{email}}」への招待を取り消しますか？',
    confirmDeletion: '「{{name}}」を削除しますか？',
    confirmUserDeletion: 'ユーザー「{{userName}}」を組織から削除しますか？',
    customAreaNameNotEntered: 'カスタムエリア名を入力してください',
    customAreaNameDuplicate: '同じ名前のカスタムエリアが既に存在しています。',
    circleCustomAreaCreatingInstructions: [
      '地図をクリックして中心点を設定してください。',
      'もう1点をクリックして半径を決めると円が作成されます。',
    ],
    circleCustomAreaEditingInstructions: [
      'ドラッグで円を移動できます。',
      '半径を変更すると自動で円の大きさが変わります。',
    ],
    polygonCustomAreaCreatingInstructions: [
      '地図をクリックして最初の頂点を設定してください。',
      '次の頂点を順にクリックしていくと多角形が作成されます。',
      'Enterキーを押すか、最初の頂点をクリックすると完了します。',
    ],
    polygonCustomAreaEditingInstructions: [
      'ドラッグで多角形を移動できます。',
      '頂点をドラッグすることで多角形の形状を編集できます。',
      'CtrlキーまたはCommandキーを押しながら頂点をクリックすると頂点を削除できます。',
      'CtrlキーまたはCommandキーを押しながら辺をクリックすると頂点を追加できます。',
    ],
    walkingCustomAreaCreatingInstructions: [
      '地図をクリックして起点を設定してください。',
      '徒歩分数に応じたカスタムエリアが自動で作成されます。',
    ],
    walkingCustomAreaEditingInstructions: [
      '徒歩分数を変更すると自動でカスタムエリアの形状が変わります。',
    ],
    deletingMember: 'メンバーを削除中...',
    downloadAnalysisResult: '分析結果をCSV形式でダウンロードします',
    downloadCancelled:
      '条件が変更されたため、ダウンロードがキャンセルされました。',
    emailInvalid: '正しいメールアドレスの形式で入力してください',
    emailRequired: 'メールアドレスを入力してください',
    failedToCancelInvitation: '招待の取消に失敗しました',
    failedToDelete: '削除に失敗しました',
    failedToDeleteMember: 'メンバーの削除に失敗しました',
    failedToInviteMember: '招待の作成に失敗しました',
    failedToSaveCustomArea: 'カスタムエリアの保存に失敗しました。',
    failedToUpdateMember: 'メンバー情報の更新に失敗しました',
    failedToUpdateName: '名前の更新に失敗しました',
    failedToUploadFile:
      'アップロードに失敗しました。ファイルの形式を確認してください。',
    fileTooLarge:
      'ファイルサイズが大きすぎます。{{max}}MB以下のファイルを選択してください。',
    invalidRadius: '半径は{{min}}kmから{{max}}km以内で設定してください',
    invalidWalkingMins:
      '徒歩分数は{{min}}分から{{max}}分以内で設定してください',
    invitationCancelled: '招待の取消に成功しました',
    invitingMember: '招待を作成中...',
    memberDeleted: 'メンバーの削除に成功しました',
    memberInfoCannotBeModified:
      'メンバー作成後、メールアドレスや権限を後から変更できません。変更したい場合、一度そのメンバーを削除したのち再度作成してください。',
    memberInvited: '招待の作成に成功しました',
    memberUpdated: 'メンバー情報の更新に成功しました',
    nameChanged: '「{{from}}」を「{{to}}」に変更しました',
    nameRequired: 'ユーザー名を入力してください',
    newBadge: {
      customArea:
        'カスタムエリアの編集・名前変更・保存・削除を一覧にまとめました。また、編集がしやすいUIを改善しました。',
      colorPalette:
        '地図の色の塗り分けを変更できるようにいたしました。お好みに合わせてご利用ください。',
    },
    noAgentFound: '条件を満たす Agent がありません。',
    noAggregationTarget: '集計対象が設定されていません。',
    noCustomAreaDisplayed: '表示中のカスタムエリアがありません。',
    noCustomAreaFound: '条件を満たすカスタムエリアがありません。',
    noDataFound: '条件を満たすデータがありません',
    noTripFound: '条件を満たす Trip がありません。',
    noFiltersApplied: '適用中のフィルターはありません',
    odMapUnavailable:
      'ODマップを表示するためには出発地、到着地または通過地点(道路・路線)を設定する必要があります。',
    operationCannotBeCancelled: 'この操作は後から取り消しできません。',
    passageTimeUnavailableDueToConditions:
      '通過地点（道路・路線）が条件に設定されていないため、通過時刻の表示はできません。',
    savedCustomArea: 'カスタムエリア「{{name}}」を保存しました',
    selectArea:
      '分析したいエリアをクリックしてください。Shiftキーを押しながらクリックすると同時に複数のエリアを選択できます。また、カスタムエリアを作成して自由な範囲を指定することも可能です。',
    selectAnalysisCondition: '分析条件にチェックを入れてください',
    selectToCompare: '比較対象を選択してください。',
    setFilters:
      '選択したエリアに対して、分析条件を設定してください。条件を設定すると、対象人数や地図に反映されます。',
    shareLinkCopied1: '共有リンクをクリップボードにコピーしました。',
    shareLinkCopied2:
      '分析結果を共有するにはコピーされたURLを共有してください。',
    startAnalysis: '分析を始めましょう。',
    stayingPopulationUnavailableDueToConditions:
      '出発地点や通過地点を条件に設定しているため、滞在人口の表示はできません。',
    supportedFileFormats:
      '現在サポートしているのは、GeoJSONまたはWKT形式のポリゴンのみとなります。「MultiPolygon」や「FeatureCollection」は別々のポリゴンとして扱われます。また、ポリゴンの穴は無視されます。',
    unexpectedError: '予期しないエラーが発生しました。',
    updatingMember: 'メンバー情報を更新中...',
    welcome: '<logo /> へようこそ。',
  },
  moveToThere: 'この地点に移動する',
  nationality: '国籍',
  newTab: '別タブ',
  notice: '通知',
  notification: 'お知らせ',
  odMap: 'ODマップ',
  odMapType: 'ODマップタイプ',
  opacity: '透明度',
  openInNewTab: '別タブで開く',
  openMapInNewTab: '現在の地図を別タブで開きなおします',
  or: 'または',
  orgMemberList: '組織メンバー一覧',
  pass: '通過',
  passageTime: '通過時刻',
  passed: '{{place}}を通過した',
  polygon: '多角形',
  quantile: '等分位',
  quantize: '等間隔',
  radius: '半径',
  rename: '名前を変更',
  roadStreet: '道路・路線',
  role: '権限',
  roleAdmin: '管理者',
  roleMember: '一般',
  save: '保存',
  saveArea: 'エリアを保存',
  saved: '保存済み',
  scale: '階級',
  searchCustomArea: 'カスタムエリアを検索',
  searchOnMap: 'マップを検索する',
  selectArea: 'エリアを選択',
  selectCustomArea: 'カスタムエリアを選択',
  selectData: 'データを選択',
  selectCustomizedData: 'カスタマイズGADデータを選択',
  selectGadAllJapanData: '対象月と地域を選択してください',
  selectingMultipleAreas: '{{count}}件のエリアを選択中',
  selectingMultipleLinks: '{{count}}本の道路・路線を選択中',
  setFilters: 'フィルターを設定',
  share: 'シェア',
  showAgain: '再表示',
  showAllTrips: 'すべての移動を表示する',
  showCustomData: 'カスタムGADを表示',
  startingGuide: '使い方ガイド',
  startPlace: '出発地',
  startSelectingExcursionArea: '回遊エリアを選択する',
  startWithoutArea: 'エリアを指定せずに分析を開始する',
  stayingPopulation: '滞在人数',
  stayingTime: '滞在時刻',
  stayingTimeRange: '滞在時間帯',
  stopBy: '立ち寄り',
  stopByAfter: '後立ち寄り',
  stopByAll: '全ての立ち寄り',
  stopByBefore: '前立ち寄り',
  stopSelectingExcursionArea: '回遊エリアの選択を終了する',
  submit: '登録',
  summary: 'サマリー',
  targetAgentCount: '対象人数',
  theme: 'テーマ',
  theseAreas: 'これらのエリア',
  theseLinks: 'これらの道路・路線',
  traffic: '交通量',
  traveledDistance: '移動距離',
  travelMode: {
    airplane: '飛行機',
    bike: '自転車',
    car: '車',
    bus: 'バス',
    rail: '鉄道',
    ship: '船',
    walk: '徒歩',
    other: 'その他',
  },
  traveledTime: '移動時間',
  tripAnalysis: '移動の分析',
  tripCounts: '移動回数',
  tripEnd: '到着地点',
  tripExcursion: '回遊地点',
  tripPass: '通過地点',
  tripPath: '移動経路',
  tripStart: '出発地点',
  undo: '一つ戻す',
  unit: {
    agent: '人',
    agentPerArea: '人/km²',
    car: '台',
    mins: '分',
  },
  unknown: '不明',
  visit: '来街地',
  visualizeInThreeDMode: '3Dモードで表示する',
  walkingDistance: '徒歩圏',
  weekday: '平日',
  work: '勤務地',
  yearAndMonth: '{{year}}年{{month}}月',
  zoom: 'ズーム',
} as const;

export { ja };
